var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestrictTypeAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7142",
    "data-name": "Group 7142",
    transform: "translate(18204 -7383.439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984",
    "data-name": "Ellipse 2984",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(-18199.424 7383.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M11.937,12.83H0v-2.29A10.541,10.541,0,0,1,15.895,1.461a7.352,7.352,0,0,0-5.356,7.061,7.278,7.278,0,0,0,1.4,4.306Z",
    transform: "translate(-18204 7395.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986",
    "data-name": "Ellipse 2986",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(-18191 7398.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6425",
    "data-name": "Rectangle 6425",
    width: 1.25,
    height: 12.41,
    rx: 0.625,
    transform: "translate(-18181.775 7398.551) rotate(41)",
    fill: "#36c96d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictTypeAddIcon);
export default __webpack_public_path__ + "static/media/RestrictTypeAddIcon.59c68311bf15c20a2d5561a75aa9a507.svg";
export { ForwardRef as ReactComponent };